import retry from "./retry";

export async function scrollWindowForIOsToTop() {
    await retry(2, 50, () => {
        window.scrollTo(0, 0);
    });
}

export function scrollWindowForIOsBy(height: number) {
    window.scrollBy(0, height);
}
